// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"0b607782","219":"15c96687","235":"66463079","264":"33a418e3","548":"b1158b04","600":"04aee74e","601":"414e8d5f","652":"c1f821c9","845":"71df1e26","855":"ddf192fb"}[chunkId] + ".chunk.js";
};